import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BellRing, X } from "lucide-react";
import { api } from "../lib/api";

export const AlertsPanel = () => {
  const [alerts, setAlerts] = useState([]);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/admin/alerts").then((r) => setAlerts(r.data)).catch(() => setAlerts([]));
  }, []);
  if (!alerts.length) return null;
  const dismiss = async (pid) => {
    await api.delete(`/admin/alerts/${pid}`);
    setAlerts((a) => a.filter((x) => x.project_id !== pid));
  };
  return (
    <section data-testid="admin-alerts" className="space-y-2 fade-up">
      {alerts.map((a, i) => (
        <div key={a.project_id} data-testid={`admin-alert-${i}`} onClick={() => nav(`/projeto/${a.project_id}`)}
          className="cursor-pointer flex items-start gap-3 rounded-lg border border-[#F39C12]/60 bg-[#F39C12]/10 px-4 py-3 hover:bg-[#F39C12]/15 transition-colors">
          <BellRing className="w-5 h-5 text-[#F39C12] shrink-0 mt-0.5" />
          <div className="min-w-0 flex-1 text-sm">
            <p className="font-semibold text-[#F39C12]">{a.new ? <span data-testid={`admin-alert-new-${i}`} className="mr-2 rounded bg-[#10B981] px-1.5 py-0.5 text-[10px] font-bold uppercase text-black">Novo projeto</span> : null}{a.new ? "Projeto recebido na central" : "Aviso de cliente — confira o projeto"}</p>
            <p className="text-[#D1D5DB]">{a.message}</p>
            <p className="font-mono text-[10px] text-[#6B7280]">{new Date(a.at).toLocaleString("pt-BR")}</p>
          </div>
          <button data-testid={`dismiss-alert-${i}`} title="Dispensar" onClick={(e) => { e.stopPropagation(); dismiss(a.project_id); }}
            className="p-1 rounded text-[#9CA3AF] hover:text-white"><X className="w-4 h-4" /></button>
        </div>
      ))}
    </section>
  );
};
